import { create } from 'zustand'
import { DEFAULT_SALES_PAGE_SIZE } from '@/features/sales/constants'

export type SalesRangePreset = 'today' | 'yesterday' | 'last_week' | 'custom'

export interface SalesCustomRange {
  from?: string
  to?: string
}

interface SalesHistoryViewState {
  page: number
  limit: number
  rangePreset: SalesRangePreset
  customRange: SalesCustomRange
}

interface SalesHistoryState {
  view: SalesHistoryViewState
}

interface SalesHistoryActions {
  setPage: (page: number) => void
  setLimit: (limit: number) => void
  setRangePreset: (preset: SalesRangePreset) => void
  setCustomRange: (range: SalesCustomRange) => void
  reset: () => void
}

const initialState: SalesHistoryState = {
  view: {
    page: 1,
    limit: DEFAULT_SALES_PAGE_SIZE,
    rangePreset: 'today',
    customRange: {},
  },
}

export const useSalesHistoryStore = create<SalesHistoryState & SalesHistoryActions>()(
  (set) => ({
    ...initialState,

    setPage: (page) => {
      set((state) => ({
        view: { ...state.view, page: Math.max(1, page) },
      }))
    },

    setLimit: (limit) => {
      set((state) => ({
        view: { ...state.view, page: 1, limit },
      }))
    },

    setRangePreset: (preset) => {
      set((state) => ({
        view: {
          ...state.view,
          page: 1,
          rangePreset: preset,
          customRange: preset === 'custom' ? state.view.customRange : {},
        },
      }))
    },

    setCustomRange: (range) => {
      set((state) => ({
        view: {
          ...state.view,
          page: 1,
          rangePreset: 'custom',
          customRange: range,
        },
      }))
    },

    reset: () => {
      set(initialState)
    },
  }),
)
